import { Badge } from '@/components/ui/badge'
import { Clock, CheckCircle, XCircle } from 'lucide-react'
import { RoosterMatchStatus } from '@/types/rooster-match.type'

export const getStatusLabel = (status: string) => {
  const statusLabels = {
    [RoosterMatchStatus.OPEN]: 'เปิดรับคู่แข่ง',
    [RoosterMatchStatus.PENDING_APPROVAL]: 'รอการอนุมัติ',
    [RoosterMatchStatus.APPROVED]: 'อนุมัติแล้ว',
    [RoosterMatchStatus.REJECTED]: 'ปฏิเสธ',
    [RoosterMatchStatus.CANCELLED]: 'ยกเลิก',
    [RoosterMatchStatus.COMPLETED]: 'เสร็จสิ้น',
    [RoosterMatchStatus.IN_PROGRESS]: 'กำลังแข่งขัน',
  }

  return statusLabels[status as keyof typeof statusLabels] || status
}

export const getStatusBadge = (status: string) => {
  const statusConfig = {
    OPEN: {
      label: 'เปิดรับคู่แข่ง',
      variant: 'default' as const,
      icon: Clock,
    },
    PENDING_APPROVAL: {
      label: 'รอการอนุมัติ',
      variant: 'secondary' as const,
      icon: Clock,
    },
    APPROVED: {
      label: 'อนุมัติแล้ว',
      variant: 'default' as const,
      icon: CheckCircle,
    },
    REJECTED: {
      label: 'ปฏิเสธ',
      variant: 'destructive' as const,
      icon: XCircle,
    },
    CANCELLED: {
      label: 'ยกเลิก',
      variant: 'outline' as const,
      icon: XCircle,
    },
    COMPLETED: {
      label: 'เสร็จสิ้น',
      variant: 'secondary' as const,
      icon: CheckCircle,
    },
    IN_PROGRESS: {
      label: 'กำลังแข่งขัน',
      variant: 'default' as const,
      icon: Clock,
    },
  }

  const config = statusConfig[status as keyof typeof statusConfig]
  if (!config) return null

  const Icon = config.icon

  return (
    <Badge variant={config.variant} className="flex items-center gap-1">
      <Icon className="h-3 w-3" />
      {config.label}
    </Badge>
  )
}
